module.exports = __webpack_public_path__ + "static/media/thumbnail_GSB_RGB_4x_white.0cafd4a7.png";